export default {"src":"/_next/static/media/tlwi-dev-new-logo.d3fe12d8.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};